// COMMENTED OUT - Unused imports
// import { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
// import Button from "@surgia/ui/components/button";
// import { useGetBranches } from "../../../hooks/useGetBranches";
// import { lookupQueries } from "@surgia/api/src/queryStore/shared/lookup";
// import { getLocalStorageItem } from "../../Catalog";

// const tenant_id = getLocalStorageItem("tenant_id", 0);

export default function General() {
  // COMMENTED OUT - Unused params and state
  // const { id: branchId } = useParams<{ id: string }>();

  // COMMENTED OUT - All the original form implementation
  /*
  // Get branch details
  const { data: branch } = useGetBranches({
    tenant_id: tenant_id,
    component_id: import.meta.env.VITE_PUBLIC_COMPONENT_ID,
    size: 1,
    page: 0,
    branches_ids: branchId,
  });

  // Get cities
  const { data: citiesData, isLoading: isCitiesLoading } = useQuery({
    ...lookupQueries.queries.cities({ country_id: 191 }),
  });

  const [formData, setFormData] = useState({
    branchName: branch?.branches[0]?.name || "",
    city: branch?.branches[0]?.city || "",
    district: branch?.branches[0]?.area || "",
    address: branch?.branches[0]?.address?.full_address || "",
    firstName: branch?.branches[0]?.contact_person?.first_name || "",
    lastName: branch?.branches[0]?.contact_person?.last_name || "",
    email: "",
    phone: "",
    city_id: branch?.branches[0]?.city_id || "",
    area_id: branch?.branches[0]?.area_id || "",
  });

  // Get selected city ID for areas query
  const selectedCityId = formData.city?.id;

  // Get areas based on selected city
  const { data: areasData, isLoading: isAreasLoading } = useQuery({
    ...lookupQueries.queries.areas({ city_id: selectedCityId }),
    enabled: !!selectedCityId,
  });

  // Update form data when branch data is loaded
  useEffect(() => {
    if (branch?.branches?.[0]) {
      const branchData = branch.branches[0];
      setFormData({
        branchName: branchData.name || "",
        city: branchData.city || "",
        district: branchData.area || "",
        address: branchData.address?.full_address || "",
        firstName: branchData.contact_person?.first_name || "",
        lastName: branchData.contact_person?.last_name || "",
        email: branchData.contact_person?.email || "",
        phone: branchData.contact_person?.mobile || "",
        city_id: "",
        area_id: "",
      });
    }
  }, [branch]);

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Reset district when city changes
    if (field === "city") {
      // Find the city ID for the selected city name
      const selectedCity = citiesData?.data?.find(
        (city: any) => city.name === value
      );
      const cityId = selectedCity?.id?.toString() || "";

      setFormData((prev) => ({
        ...prev,
        [field]: value,
        cityId: cityId, // Update cityId when city changes
        district: "", // Reset district
      }));
    }
  };

  const handleCityChange = (cityName: string) => {
    const selectedCity = citiesData?.data?.find(
      (city: any) => city.name === cityName
    );

    setFormData((prev) => ({
      ...prev,
      city: selectedCity || null,
      district: "", // Reset district when city changes
    }));
  };

  const handleSave = () => {};

  const handleCancel = () => {};
  */

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow p-6">
      <h2 className="text-lg font-semibold mb-4">Branch Details</h2>
      <p className="text-gray-600">
        Branch details form will be implemented here.
      </p>

      {/* COMMENTED OUT - Original form implementation
      <div className="min-h-screen flex flex-col items-center  py-8">
        <div className="mb-8 w-full">
          <div className="flex w-full justify-between px-5 gap-32">
            <h3 className="text-md text-[#414651] mb-6">Branch details</h3>
            <div className="grid grid-cols-2 gap-4 border border-[#E9EAEB] shadow-xs rounded-xl p-6 bg-white flex-1">
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Branch name
                </label>
                <input
                  type="text"
                  value={formData.branchName}
                  onChange={(e) =>
                    handleInputChange("branchName", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City
                </label>
                <select
                  value={formData.city?.name || ""}
                  onChange={(e) => handleCityChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  disabled={isCitiesLoading}
                >
                  <option value="">Select City</option>
                  {citiesData?.data?.map((city: any) => (
                    <option key={city.id} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  District
                </label>
                <select
                  value={formData.district}
                  onChange={(e) => handleInputChange("district", e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  disabled={isAreasLoading || !selectedCityId}
                >
                  <option value="">Select District</option>
                  {areasData?.data?.map((area: any) => (
                    <option key={area.id} value={area.name}>
                      {area.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Address
                </label>
                <textarea
                  value={formData.address}
                  onChange={(e) => handleInputChange("address", e.target.value)}
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                  placeholder="Enter complete address including street, building number, postal code, etc."
                />
              </div>
              <div className="flex justify-end gap-3 mt-6 col-span-2">
                <Button
                  variant="outline"
                  onClick={handleCancel}
                  className="px-4 py-2"
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={handleSave}
                  className="px-4 py-2"
                >
                  Save changes
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
    </div>
  );
}
